import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { CrewDataService } from 'src/app/services/crew-data.service';
import { FilterService } from 'src/app/services/filter.service';
import { CustomDialogService } from '../../custom-dialog.service';
import { AppConstant } from 'src/app/utilities/app.constants';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';
import { Observable, of } from "rxjs";
import * as XLSX from 'xlsx';
import { Router, NavigationEnd } from '@angular/router';



@Component({
  selector: 'nomination-filter',
  templateUrl: './nomination-filter.component.html',
  styleUrls: ['./nomination-filter.component.scss']
})
export class NominationFilterComponent implements OnInit {
  @Input() showAdd = true;
  @Input() showBulkUpload = true;
  @Input() showFirmFilter = true;
  @Input() showCrewIdFilter = true;
  @Input() showNationalityFilter = true;
  @Input() showPeriodFilter = true;
  @Input() showAgeGroupFilter = true;
  @Input() showCategoryFilter = true;
  @Input() showDepartmentFilter = true;
  @Input() showShortListedButton = true;
  @Input() csvpdfparent: string;
  @Input() pdfparent: string;
  @Input() filterStatusForPage = true;
  @Input() shortlistingDone=false;
  @Output() add = new EventEmitter();
  @Output() fetchdata = new EventEmitter();
  @Output() fetchdataCat = new EventEmitter();
  @Output() fetchdataRank = new EventEmitter();
  @Output() fetchdataByname = new EventEmitter();
  @Output() fetchdataByVesselName = new EventEmitter();
  @Output() fetchdataByCrewId = new EventEmitter();
  @Output() fetchdataByPeriod = new EventEmitter();
  @Output() fetchdataByFirm = new EventEmitter();
  @Output() fetchdataByAgeGroup = new EventEmitter();
  @Output() fetchViewType = new EventEmitter();
  @Output() generatePDF = new EventEmitter();
  @Output() fetchdataByNational = new EventEmitter();
  @Output() mail = new EventEmitter();
  @Output() outlierData = new EventEmitter();

  @ViewChild('searchInputDep', { static: false }) searchInputDep: ElementRef;
  @ViewChild('searchInputCat', { static: false }) searchInputCat: ElementRef;
  @ViewChild('searchInputRank', { static: false }) searchInputRank: ElementRef;
  @ViewChild('searchInputName', { static: false }) searchInputName: ElementRef;
  @ViewChild('searchInputCrewId', { static: false }) searchInputCrewId: ElementRef;
  @ViewChild('searchInputPeriod', { static: false }) searchInputPeriod: ElementRef;
  @ViewChild('searchFirm', { static: false }) searchFirm: ElementRef;
  @ViewChild('searchInputAge', { static: false }) searchInputAge: ElementRef;

  crewList = [];
  crewListClone = [];
  departments = [];
  categories = [];
  ranks = [];
  period = ['Last 6 Months', 'Last 1 Year'];
  departCatRankList: any;
  department: any;
  rank: any;
  category: any;
  nationalityList: any;
  msg: string;
  bulkUploadFileStatus = true;
  mySubscription: any;
  isListView = true;
  filterPool : any = [];
  firmList = [];
  ageGroupArray = ['18 - 25', '26 - 30', '31 - 35', '36 - 40', 'Above 40'];
  toggleImage = '../../../../../../assets/images/toggle-chartview.png';
  outlierChecked = false;

  dropdownList = [];
  ageSelectedItems :any = [];
  dropdownSettings = {};
  dropdownSingleSelectionSettings = {};
  selectedNations : any = [];
  selectedRanks : any = [];
  selectedPeriod :any = [];
  selectedFirm : any = [];
  selectedDepartment :any = [];
  selectedCategories :any = [];
  tempFilterToRemove: any;
  tempFilterLocation: any = 0;
  previousFilterName: any;
  @Input() selectedNominees: any[] = [];
  @Output() shortlistSubmitted = new EventEmitter<any[]>();
  constructor(private crewService: CrewDataService,
    private customDialogService: CustomDialogService,
    private filterService: FilterService,
    public appSpinner: AppSpinnerService,
    private router: Router
  ) {
    this.filterService.analyticsSubject.subscribe((data: any) =>{
			this.toggleImage = '../../../../../../assets/images/toggle-chartview.png';
      this.isListView = true;
      // for(let index =  0;index<this.filterPool.length;index++){
      //   console.log('data log ',this.filterPool[index]);
      //   setTimeout(function(){
      //     this.removeDataPoolFromFilterPool(this.filterPool[index]);
      //   },1000);
      // }
			
      this.removeSelectedFiltersList();
      this.filterPool = [];
     
			this.filterService.filterPoolSubject.next(this.filterPool);
      this.fetchViewType.emit(data);
		})
  }
  

  submitShortlist() {
    this.shortlistSubmitted.emit(this.selectedNominees);
  }
  ngOnInit() {
//this.searchInputDep.nativeElement.value ='Select';
    this.nationalityList = this.crewService.getCounteries();
    this.crewService.getDepartmentCatRank().subscribe((data: any) => {
      if (data) {
        console.log('data', data);
        this.departCatRankList = data;
      //  this.getDepartment();
      //  this.getCategory();
        this.getRank();
      }
    })
   // this.loadEntireCrewList();
  //  this.getFirmsList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true,
      enableCheckAll: false
    };
    this.dropdownSingleSelectionSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true,
      enableCheckAll: false
    };

  }

  getDepartment() {
    this.departments = [];
    for (let i = 0; i < this.departCatRankList.length; i++) {
      if (this.departments.indexOf(this.departCatRankList[i].department) == -1) {
        this.departments.push(this.departCatRankList[i].department);
      }
    }
  }

  getCategory() {
    this.categories = [];
    for (let i = 0; i < this.departCatRankList.length; i++) {
      if (this.categories.indexOf(this.departCatRankList[i].category) == -1) {
        this.categories.push(this.departCatRankList[i].category);
      }
    }
    this.getRank();
  }

  getRank() {
    this.ranks = [];
    for (let i = 0; i < this.departCatRankList.length; i++) {
      if (this.ranks.indexOf(this.departCatRankList[i].rank) == -1) {
        this.ranks.push(this.departCatRankList[i].rank);
      }
    }
  }

  loadEntireCrewList() {
    this.crewService.getAllCrew().subscribe((data: any) => {
      console.log('loadEntireCrewList ', data);
      this.crewList = data;
      this.crewListClone = data;
    });
  }

  getFirmsList() {
    this.crewService.getListFirms().subscribe((data: any) => {
      console.log('firms ', data);
      this.firmList = data;
    })
  }

  resetAll(){
    let data = {option: "department", name: "Deck"}
    this.removeDataFromFilterPool(data);
  }

  onAdd() {
    this.add.emit();
  }

  onAddPDF() {
    this.filterService.csvSubject.next(this.pdfparent);
    this.generatePDF.emit()
  }

  onAddCSV() {
    console.log("csvParent0", this.csvpdfparent);
    this.filterService.csvSubject.next(this.csvpdfparent);
  }

  onBulkUpload() {
    this.msg = AppConstant.BULK_UPLOAD;
    this.customDialogService.showDialog(this.msg, 'dismiss');
  }

  onClickMail() {
    if(!this.isListView) {
    this.mail.emit();
    }
    else if (this.isListView && this.filterStatusForPage) {
    this.filterService.emailSubject.next('AnalyticsEmail');
    }
    else if (!this.filterStatusForPage) {
      this.filterService.emailCrewListSubject.next('CrewDataEmail');
    }
  }

  filterByCrewId(event: any) {
    const searchedText = event.srcElement.value;
    let data = { event: searchedText };
    this.fetchdataByCrewId.emit(data);
  }

 /*  filterByCrewMembername(event: any) {
    const searchedText = event.srcElement.value.toLowerCase();
    let data = { event: searchedText };
    console.log('name', data);
    this.fetchdataByname.emit(data);
  }
  filterByVesselName(event: any) {
    const searchedText = event.srcElement.value.toLowerCase();
    let data = { event: searchedText };
    console.log('Vessel', data);
    this.fetchdataByVesselName.emit(data);
  }
 */

crewNameFilter: string = '';
vesselNameFilter: string = '';
//selectedRanks: string[] = [];

@Output() combinedFilterEvent = new EventEmitter<any>();

onNameChange(event: any) {
  this.crewNameFilter = event.target.value.trim().toLowerCase();
  this.emitCombinedFilters();
}

onVesselNameChange(event: any) {
  this.vesselNameFilter = event.target.value.trim().toLowerCase();
  this.emitCombinedFilters();
}

/* onSelectRank(event: string[]) {
  this.selectedRanks = event.map(rank => rank.toLowerCase());
  this.emitCombinedFilters();
} */
emitCombinedFilters() {
  const filterData = {
    name: this.crewNameFilter,
    shipName: this.vesselNameFilter, // replaces vesselName
    ranks: this.selectedRanks
  };

  this.combinedFilterEvent.emit(filterData);
}

  resetDropDownAndFilters(){
    console.log('test ',this.selectedFirm);
    this.filterPool = [];
    let data = { event: 'Select' };
    if(this.selectedCategories.length > 0){
      this.searchInputCat.nativeElement.value = 'Select';
      this.selectedCategories = [];
      this.fetchdataCat.emit(data);
    }
    if(this.selectedDepartment.length > 0){
      this.searchInputDep.nativeElement.value = 'Select';
      this.selectedDepartment = [];
      this.fetchdata.emit(data);
    }
    if(this.selectedRanks.length > 0){
      // this.searchInputRank.nativeElement.value = 'Select';
      this.selectedRanks = [];
      this.fetchdataRank.emit(data);
    }
    if(this.selectedNations.length > 0){
      this.selectedNations = [];
      this.fetchdataByNational.emit(data);
    }
    if(this.ageSelectedItems.length > 0){
      this.ageSelectedItems = [];
      this.fetchdataByAgeGroup.emit(data);
    }
    if(this.selectedPeriod.length > 0){
      this.searchInputPeriod.nativeElement.value = 'From Beginning';
      this.selectedPeriod = [];
    }
    if(this.searchFirm.nativeElement.value != 'Select'){
      this.searchFirm.nativeElement.value = 'Select';
      this.selectedFirm = [];
      this.fetchdataByFirm.emit(data);
    }
    this.filterService.filterPoolSubject.next(this.filterPool);
  }



  checkOutlier() {
    console.log('123');
    this.resetDropDownAndFilters();
     
    this.outlierChecked = !this.outlierChecked;
    this.outlierData.emit(this.outlierChecked);
    this.removeDataFromFilterPool({ 'option': 'outlier', 'name': !this.outlierChecked })
    this.saveToFilterPool({option: 'outlier', name: this.outlierChecked });
  }

  // onSelectFirm(event: any) {
  //   console.log('firm name ', event);
  //   const firmName = event;
  //   let data = { event: firmName };
  //   this.fetchdataByFirm.emit(data);
  //   this.removeTypeDataFromFilterPool('firm');
  //   let filterPoolData = { option: 'firm', name: firmName };
  //   this.saveToFilterPool(filterPoolData);
  //   this.selectedFirm.push(filterPoolData);
  // }

  onSelectFirm(event: any) {
    console.log('firm name ', event.srcElement.value);
    const firmName = event.srcElement.value;
    let data = { event: firmName };

    if (firmName !== 'Select') {
      this.fetchdataByFirm.emit(data);
      this.removeTypeDataFromFilterPool('firm');
      let filterPoolData = { option: 'firm', name: firmName };
      this.saveToFilterPool(filterPoolData);
      //this.selectedFirm.push(filterPoolData);
      // console.log('firm selected ',this.selectedFirm);
    }
    else if (firmName == 'Select') {
      this.removeTypeDataFromFilterPool('firm');
      this.selectedFirm = [];
      this.fetchdata.emit(data);
    }
  }


  onSelectDepartment(event: any) {
    this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
    // this.searchInputRank.nativeElement.value = 'Select Rank';
    this.searchInputCat.nativeElement.value = 'Select';
    // this.searchInputPeriod.nativeElement.value = 'From Beginning';
    const searchedText = event.srcElement.value;
    let data = { event: searchedText };
    if (searchedText !== 'Select') {
      this.fetchdata.emit(data);
      this.removeTypeDataFromFilterPool('department');
      let filterPoolData = { option: 'department', name: searchedText };
      this.removeTypeDataFromFilterPool('rank');
      this.removeTypeDataFromFilterPool('category');
      this.saveToFilterPool(filterPoolData);
      this.selectedDepartment.push(filterPoolData);
      this.selectedRanks = [];
      this.selectedCategories = [];
    }
    else if (searchedText == 'Select') {
      this.removeTypeDataFromFilterPool('department');
      this.selectedDepartment = [];
      this.fetchdata.emit(data);
    }
  }


  onSingleSelectRanks(event: any) {
    this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
    this.searchInputDep.nativeElement.value = 'Select';
    this.searchInputCat.nativeElement.value = 'Select';
    const searchedText = event.srcElement.value;
    let data = { event: searchedText };
    if (searchedText !== 'Select') {
      this.fetchdataRank.emit(data);
      this.removeTypeDataFromFilterPool('rank');
      let filterPoolData = { option: 'rank', name: searchedText };
      this.removeTypeDataFromFilterPool('department');
      this.removeTypeDataFromFilterPool('category');
      this.saveToFilterPool(filterPoolData);
      this.selectedRanks.push(filterPoolData);
      this.selectedDepartment = [];
      this.selectedCategories = [];
    }
    else if (searchedText == 'Select') {
      this.removeTypeDataFromFilterPool('rank');
      this.selectedRanks = [];
      this.fetchdataRank.emit(data);
    }
  }



  onSelectCategory(event: any) {
    this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
    this.searchInputDep.nativeElement.value = 'Select';
    // this.searchInputRank.nativeElement.value = 'Select Rank';
    // this.searchInputPeriod.nativeElement.value = 'From Beginning';
    const searchedText = event.srcElement.value;
    let data = { event: searchedText };
    if (searchedText !== 'Select') {
      this.fetchdataCat.emit(data);
      this.removeTypeDataFromFilterPool('category');
      let filterPoolData = { option: 'category', name: searchedText };
      this.removeTypeDataFromFilterPool('department');
      this.removeTypeDataFromFilterPool('rank');
      this.saveToFilterPool(filterPoolData);
      this.selectedCategories.push(filterPoolData);
      this.selectedRanks = [];
      this.selectedDepartment = [];
    }
    else if (searchedText == 'Select') {
      this.removeTypeDataFromFilterPool('category');
      this.selectedCategories = [];
      this.fetchdataCat.emit(data);
    }
  }

  getFilterTypeCountInFilterPool(filterType) {
    let filterTypeCount = 0;
    for (let index = 0; index < this.filterPool.length; index++) {
      if (this.filterPool[index].option == filterType) {
        filterTypeCount++;
      }
    }
    return filterTypeCount;
  }
  onSelectRank(event: any) {

    this.changeMultiFilterOption(this.selectedRanks, event, 'rank');
   // this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
   // this.searchInputDep.nativeElement.value = 'Select';
   // this.searchInputCat.nativeElement.value = 'Select';
    const searchedText = event;
    if (this.filterStatusForPage) {

    }
    else {
      console.log('else ', this.filterStatusForPage);
      this.removeTypeDataFromFilterPool('rank');
    }

    /* let checkFilterStatus = this.onCheckFilterEmpty('age', 'nation', 'department', 'category', 'period', 'firm');
    if (checkFilterStatus == true) {
      console.log('here rank');
      let data = { operation: '1', event: searchedText };
      this.fetchdataRank.emit(data);
    }
    else {
      let data = { event: searchedText };
      this.fetchdataRank.emit(data);
    } */

    // this.selectedRanks.push(event);
    console.log('data ranks ', this.selectedRanks);
    let filterPoolData = { option: 'rank', name: searchedText };
   // this.removeTypeDataFromFilterPool('department');
    //this.removeTypeDataFromFilterPool('category');
    this.saveToFilterPool(filterPoolData);
   // this.selectedDepartment = [];
   // this.selectedCategories = [];
  }

  onselectNationality(event: any) {
    this.changeMultiFilterOption(this.selectedNations, event, 'nation');
    this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
    const searchedText = event;
    let checkFilterStatus = this.onCheckFilterEmpty('rank', 'age', 'department', 'category', 'period', 'firm');


    if (checkFilterStatus == true) {
      console.log('here');
      let data = { operation: '1', event: searchedText };
      this.fetchdataByNational.emit(data);
    }
    else {
      console.log('there');
      let data = { event: searchedText };
      this.fetchdataByNational.emit(data);
    }
    let filterPoolData = { option: 'nation', name: searchedText };
    this.saveToFilterPool(filterPoolData);
    console.log('selected nations ', this.selectedNations);

  }




  changeMultiFilterOption(filterSelectedItems, event, latestMultiFilterToApply) {
     if (latestMultiFilterToApply == 'rank') {
      if (this.selectedNations.length > 1) {
        if (filterSelectedItems.length == 2) {
          let changeMessage = "Do you want to select multiple option, Multifilter on nation will reset."
          this.customDialogService.showDialogBackDrop(changeMessage, 'yes').subscribe(actionType => {
            console.log('actionType ', actionType);
            if (actionType == 'yes') {
              this.removeOtherMultiFilter(this.filterPool, 'nation');
              this.selectedNations = [];
              // this.emitAllFilterFromFilterPool();
            }
            else {
              if (latestMultiFilterToApply == 'rank') {
                this.removeDataFromFilterPoolMutliSelection({ 'option': 'rank', 'name': event });
                // this.removeDataFromFilterPool({'option':'rank','name':event})
              }
            }
          })
        }
        else {
          this.dropdownSettings = {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 0,
            allowSearchFilter: true,
            enableCheckAll: false,
          };
        }
      }
      else if (this.ageSelectedItems.length > 1) {
        if (filterSelectedItems.length == 2) {
          let changeMessage = "Do you want to select multiple option, Multifilter on age will reset."
          this.customDialogService.showDialogBackDrop(changeMessage, 'yes').subscribe(actionType => {
            console.log('actionType ', actionType);
            if (actionType == 'yes') {
              this.removeOtherMultiFilter(this.filterPool, 'age');
              this.ageSelectedItems = [];
              // this.emitAllFilterFromFilterPool();
            }
            else {
              if (latestMultiFilterToApply == 'rank') {
                this.removeDataFromFilterPoolMutliSelection({ 'option': 'rank', 'name': event });
                // this.removeDataFromFilterPool({'option':'rank','name':event})
              }
            }
          })
        }
        else {
          this.dropdownSettings = {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 0,
            allowSearchFilter: true,
            enableCheckAll: false,
          };
        }
      }
    }
  }


  checkMultiSelectOption(filterSelectedItems, event, latestMultiFilterToApply) {
    if (this.selectedNations.length > 1) {
      if (filterSelectedItems.length == 2) {
        let changeMessage = "Do you want to select multiple option, Multifilter on nationality will reset."
        this.customDialogService.showDialogBackDrop(changeMessage, 'yes').subscribe(actionType => {
          if (actionType == 'yes') {
            this.removeOtherMultiFilter(this.filterPool, 'nation');
          }
          else {
            // this.removeAllFilterDataByFilterType('age');
            if (latestMultiFilterToApply == 'age') {
              this.removeDataFromFilterPool({ 'option': 'age', 'name': event })
            }
            if (latestMultiFilterToApply == 'rank') {
              this.removeDataFromFilterPool({ 'option': 'rank', 'name': event })
            }
            this.dropdownSettings = {
              singleSelection: true,
              idField: 'item_id',
              textField: 'item_text',
              selectAllText: 'Select All',
              unSelectAllText: 'UnSelect All',
              itemsShowLimit: 0,
              allowSearchFilter: false,
              enableCheckAll: false,
            }
          }
        })
      }
      else {
        this.dropdownSettings = {
          singleSelection: false,
          idField: 'item_id',
          textField: 'item_text',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 0,
          allowSearchFilter: true,
          enableCheckAll: false,
        };
      }
    }
    else if (this.selectedRanks.length > 1) {
      console.log('ranks wala');
      if (filterSelectedItems.length == 2) {
        let changeMessage = "Do you want to select multiple option, Multifilter on rank will reset."
        this.customDialogService.showDialogBackDrop(changeMessage, 'yes').subscribe(actionType => {
          if (actionType == 'yes') {
            this.removeOtherMultiFilter(this.filterPool, 'rank');
          }
          else {
            // this.removeAllFilterDataByFilterType('age');
            if (latestMultiFilterToApply == 'age') {
              this.removeDataFromFilterPool({ 'option': 'age', 'name': event })
            }
            if (latestMultiFilterToApply == 'nation') {
              this.removeDataFromFilterPool({ 'option': 'nation', 'name': event })
            }
            this.dropdownSettings = {
              singleSelection: true,
              idField: 'item_id',
              textField: 'item_text',
              selectAllText: 'Select All',
              unSelectAllText: 'UnSelect All',
              itemsShowLimit: 0,
              allowSearchFilter: false,
              enableCheckAll: false,
            }
          }
        })
      }
      else {
        this.dropdownSettings = {
          singleSelection: false,
          idField: 'item_id',
          textField: 'item_text',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 0,
          allowSearchFilter: true,
          enableCheckAll: false,
        };
      }
    }
  }

  /*** method for emmitting the value to 
   * remove the a type of multifilter.
   * **/
  removeOtherMultiFilter(itemArray, filterType) {
    this.filterPool = itemArray.filter(item => item.option !== filterType);
    this.filterService.filterPoolSubject.next(this.filterPool);
  }

  onEmitSelectedValues() {
    let item = this.ageSelectedItems[0];
    let data = { event: 're-select', value: item };
    console.log('data emittable ', this.ageSelectedItems[0]);
    this.fetchdataByAgeGroup.emit(data);
  }


  emitAllFilterFromFilterPool() {
    for (let index = 0; index < this.filterPool.length; index++) {
      if (index == 0) {
        if (this.filterPool[index].option == 'rank') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdataRank.emit(data);
        }
        else if (this.filterPool[index].option == 'age') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdataByAgeGroup.emit(data);
        }
        else if (this.filterPool[index].option == 'nation') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdataByNational.emit(data);
        }
        else if (this.filterPool[index].option == 'firm') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdataByFirm.emit(data);
        }
        else if (this.filterPool[index].option == 'department') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdata.emit(data);
        }
        else if (this.filterPool[index].option == 'category') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdataCat.emit(data);
        }
        else if (this.filterPool[index].option == 'period') {
          let data = { operation: '1', event: this.filterPool[index].name };
          this.fetchdataByPeriod.emit(data);
        }
      }
      else {
        if (this.filterPool[index].option == 'rank') {
          let data = { event: this.filterPool[index].name };
          this.fetchdataRank.emit(data);
        }
        else if (this.filterPool[index].option == 'age') {
          let data = { event: this.filterPool[index].name };
          this.fetchdataByAgeGroup.emit(data);
        }
        else if (this.filterPool[index].option == 'nation') {
          let data = { event: this.filterPool[index].name };
          this.fetchdataByNational.emit(data);
        }
        else if (this.filterPool[index].option == 'firm') {
          let data = { event: this.filterPool[index].name };
          this.fetchdataByFirm.emit(data);
        }
        else if (this.filterPool[index].option == 'department') {
          let data = { event: this.filterPool[index].name };
          this.fetchdata.emit(data);
        }
        else if (this.filterPool[index].option == 'category') {
          let data = { event: this.filterPool[index].name };
          this.fetchdataCat.emit(data);
        }
        else if (this.filterPool[index].option == 'period') {
          let data = { event: this.filterPool[index].name };
          this.fetchdataByPeriod.emit(data);
        }
      }
    }
  }


  onCheckFilterEmpty(firstFilter, secondFilter, thirdFilter, fourthFilter, fifthFilter, sixthFilter) {
    let firstFilterCountInFilterPool = this.getFilterTypeCountInFilterPool(firstFilter);
    let secondFilterCountInFilterPool = this.getFilterTypeCountInFilterPool(secondFilter);
    let thirdFilterCountInFilterPool = this.getFilterTypeCountInFilterPool(thirdFilter);
    let fourthFilterCountInFilterPool = this.getFilterTypeCountInFilterPool(fourthFilter);
    let fifthFilterCountInFilterPool = this.getFilterTypeCountInFilterPool(fifthFilter);
    let sixthFilterCountInFilterPool = this.getFilterTypeCountInFilterPool(sixthFilter);
    if (firstFilterCountInFilterPool > 0 || secondFilterCountInFilterPool > 0 || thirdFilterCountInFilterPool > 0 || fourthFilterCountInFilterPool > 0 || fifthFilterCountInFilterPool > 0 || sixthFilterCountInFilterPool > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  onSelectAge(event: any) {
    this.changeMultiFilterOption(this.ageSelectedItems, event, 'age');
    this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
    const searchedText = event;
    let checkFilterStatus = this.onCheckFilterEmpty('rank', 'nation', 'department', 'category', 'period', 'firm');
    if (checkFilterStatus == true) {
      let data = { operation: '1', event: searchedText };
      this.fetchdataByAgeGroup.emit(data);
    }
    else {
      let data = { event: searchedText };
      this.fetchdataByAgeGroup.emit(data);
    }
    if (searchedText !== 'Select') {
      let filterPoolData = { option: 'age', name: searchedText };
      this.saveToFilterPool(filterPoolData);
    }
    else if (searchedText == 'Select') {
      this.removeTypeDataFromFilterPool('age');
    }

  }

  saveToFilterPool(data) {
    let baseValue = 0;
    for (let index = 0; index < this.filterPool.length; index++) {
      if (this.filterPool[index].name == data.name) {
        baseValue++;
      }
    }
    if (baseValue == 0) {
      this.filterPool.push(data);
    }

    this.filterService.filterPoolSubject.next(this.filterPool);
  }


  removeAllFilterDataByFilterType(filterType: any) {
    console.log('filtered pool 1', this.filterPool);
    let tempFilterPool = [];
    for (let index = 0; index < this.filterPool.length; index++) {
      if (this.filterPool[index].option != filterType) {
        tempFilterPool.push(this.filterPool[index]);
      }
    }
    console.log('filtered pool 2', this.filterPool);
    this.filterPool = tempFilterPool;
  }

  removeDataFromFilterPoolMutliSelection(data) {
    let count = 0;
    let temprorayFilterArray = [];
    for (let index = 0; index < this.filterPool.length; index++) {
      if (count == 0) {
        if (this.filterPool[index].option == data.option) {
          count = 1;
          temprorayFilterArray.push(this.filterPool[index]);
        }
        else if (this.filterPool[index].option != data.option) {
          temprorayFilterArray.push(this.filterPool[index]);
        }
      }
      else {
        if (this.filterPool[index].option == data.option) {
          this.removeFilterFromCheckBox(this.filterPool[index]);
        }
        else if (this.filterPool[index].option != data.option) {
          temprorayFilterArray.push(this.filterPool[index]);
        }
      }
    }
    this.filterPool = temprorayFilterArray;
    this.filterService.filterPoolSubject.next(this.filterPool);
  }

  removeDataFromFilterPool(data) {
    console.log('before delete pool', this.filterPool);
    if (this.filterPool) {
      this.filterPool = this.filterPool.filter((item: any) => {

        return !(item.option === data.option && item.name === data.name);
      });
    }
    console.log('after delete pool 1', this.filterPool);
    this.removeFilterFromCheckBox(data);
    console.log('after delete pool 2', this.filterPool);
    console.log('data rm ', data);
    this.filterService.filterPoolSubject.next(this.filterPool);

  }

  removeDataPoolFromFilterPool(data) {
    console.log('before delete pool', this.filterPool);
    if (this.filterPool) {
      this.filterPool = this.filterPool.filter((item: any) => {

        return !(item.option === data.option && item.name === data.name);
      });
    }
    this.removeFilterFromCheckBox(data);
    console.log('after delete pool', this.filterPool);
    console.log('data rm ', data);
    this.filterService.filterPoolSubject.next(this.filterPool);

  }



  removeFilterFromCheckBox(filterObject) {
    if (filterObject.option == 'rank') {
      if (this.filterStatusForPage == true) {
        this.selectedRanks = this.selectedRanks.filter(item => item != filterObject.name);
      }
      if (this.filterStatusForPage == false) {
        this.searchInputRank.nativeElement.value = 'Select';
        let data = { event: 'Select' };
        this.fetchdataRank.emit(data);
      }
    }
    else if (filterObject.option == 'nation') {
      this.selectedNations = this.selectedNations.filter(item => item != filterObject.name);
    }
    else if (filterObject.option == 'category') {
      this.searchInputCat.nativeElement.value = 'Select';
      this.selectedCategories = [];
      if (this.filterStatusForPage == false) {
        let data = { event: 'Select' };
        this.fetchdataCat.emit(data);
      }
    }
    else if (filterObject.option == 'department') {
      this.searchInputDep.nativeElement.value = 'Select';
      this.selectedDepartment = [];
      if (this.filterStatusForPage == false) {
        let data = { event: 'Select' };
        this.fetchdata.emit(data);
      }
    }
    else if (filterObject.option == 'age') {
      this.ageSelectedItems = this.ageSelectedItems.filter(item => item != filterObject.name);
    }
    else if (filterObject.option == 'period') {
      this.searchInputPeriod.nativeElement.value = 'From Beginning';
      this.selectedPeriod = [];
    }
    else if (filterObject.option == 'firm') {
      this.searchFirm.nativeElement.value = 'Select';
      this.selectedFirm = [];
    }
  }

  removeSelectedFiltersList() {
    this.selectedRanks = [];
    this.selectedNations = [];
    this.selectedCategories = [];
    this.selectedDepartment = [];
    this.ageSelectedItems = [];
    this.selectedPeriod = [];
    this.selectedFirm = [];
  }

  resetAllDataByFilters() {
    for (let index = 0; index < this.filterPool.length;) {
      if (index == 0) {
        console.log('if');
        console.log(this.filterPool[index]);
        let data = { option: this.filterPool[index].option, status: "renew", name: this.filterPool[index].name };
        if (this.filterPool[index].option == 'rank') {
          // this.selectedRanks = this.selectedRanks.filter(item => item != this.filterPool[index].name);
          this.fetchdataRank.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'nation') {
          console.log('nation check ', index);
          // this.selectedNations = this.selectedNations.filter(item => item != this.filterPool[index].name);
          this.fetchdataByNational.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'category') {
          // this.searchInputCat.nativeElement.value = 'Select Category';
          // this.selectedCategories = [];
          this.fetchdataCat.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'department') {
          // this.searchInputDep.nativeElement.value = 'Select Department';
          // this.selectedDepartment = [];
          this.fetchdata.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'age') {
          // this.ageSelectedItems = this.ageSelectedItems.filter(item => item != this.filterPool[index].name);
          this.fetchdataByAgeGroup.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'period') {
          // this.searchInputPeriod.nativeElement.value = 'From Beginning';
          // this.selectedPeriod = [];
          this.fetchdataByPeriod.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'firm') {
          // this.searchFirm.nativeElement.value = 'Select Firm';
          // this.selectedFirm = [];
          this.fetchdataByFirm.emit(data);
          index++;
        }
      }
      else {
        console.log('else');
        let data: any;
        if (this.tempFilterLocation == 1) {
          // data =  {option:this.filterPool[index].option,preSelection:'yes',status:"selected",name:this.filterPool[index].name};
          data = { operation: '1', event: this.filterPool[index].name };
        }
        else {
          data = { option: this.filterPool[index].option, status: "selected", name: this.filterPool[index].name };
        }
        if (this.filterPool[index].option == 'rank') {
          // this.selectedRanks = this.selectedRanks.filter(item => item != this.filterPool[index].name);
          this.fetchdataRank.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'nation') {
          // this.selectedNations = this.selectedNations.filter(item => item != this.filterPool[index].name);
          this.fetchdataByNational.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'category') {
          // this.searchInputCat.nativeElement.value = 'Select Category';
          // this.selectedCategories = [];
          this.fetchdataCat.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'department') {
          // this.searchInputDep.nativeElement.value = 'Select Department';
          // this.selectedDepartment = [];
          this.fetchdata.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'age') {
          // this.ageSelectedItems = this.ageSelectedItems.filter(item => item != this.filterPool[index].name);
          this.fetchdataByAgeGroup.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'period') {
          // this.searchInputPeriod.nativeElement.value = 'From Beginning';
          // this.selectedPeriod = [];
          this.fetchdataByPeriod.emit(data);
          index++;
        }
        else if (this.filterPool[index].option == 'firm') {
          // this.searchFirm.nativeElement.value = 'Select Firm';
          // this.selectedFirm = [];
          this.fetchdataByFirm.emit(data);
          index++;
        }
      }
    }
    this.tempFilterLocation = 0;
  }

  // removeDataFromFilterPool(data){
  //   console.log('data rm ',data);
  //   let baseValue = 0;
  //     for(let index = 0; index<this.filterPool.length; index++){
  //       if(this.filterPool[index].name == data.name){
  //         baseValue = index;
  //       }
  //     }
  //     if(baseValue > -1){
  //       this.filterPool.splice(baseValue, 1);
  //     }
  //     if(data.option == 'rank'){
  //       this.selectedRanks = this.selectedRanks.filter(item => item != data.name);
  //       console.log('rm rank data',data);
  //       this.fetchdataRank.emit(data);
  //     }
  //     else if(data.option == 'nation'){
  //       this.selectedNations = this.selectedNations.filter(item => item != data.name);
  //       console.log('rm nation data',data);
  //       this.fetchdataByNational.emit(data);
  //     }
  //     else if (data.option == 'category') {
  //       this.searchInputCat.nativeElement.value = 'Select Category';
  //       this.selectedCategories = [];
  //       this.fetchdataCat.emit(data);
  //     }
  //     else if(data.option == 'department'){
  //       this.searchInputDep.nativeElement.value = 'Select Department';
  //       this.selectedDepartment = [];
  //       this.fetchdata.emit(data);
  //     }
  //     else if(data.option == 'age'){
  //       this.ageSelectedItems = this.ageSelectedItems.filter(item => item != data.name);
  //       this.fetchdataByAgeGroup.emit(data);
  //     }
  //     else if(data.option == 'period'){
  //       this.searchInputPeriod.nativeElement.value = 'From Beginning';
  //       this.selectedPeriod = [];
  //       let dataType = {event: 'From Beginning'};
  //       this.fetchdataByPeriod.emit(dataType);
  //     }
  //     else if(data.option == 'firm'){
  //       this.searchFirm.nativeElement.value = 'Select Firm';
  //       this.selectedFirm = [];
  //       let data = {event: 'Select Firm'};
  //       this.fetchdataByFirm.emit(data);
  //     }

  //     // this.emitAllFilterFromFilterPool();
  //     this.filterService.filterPoolSubject.next(this.filterPool);

  // }



  // reselectAllFilterFromFilterPool(){
  //   for(let index =  0; index < this.filterPool.length; index++){
  //     if(index == 0){
  //       if(this.filterPool[index].option == 'rank'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdataRank.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'age'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdataByAgeGroup.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'nation'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdataByNational.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'firm'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdataByFirm.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'department'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdata.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'category'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdataCat.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'period'){
  //         let data = {operation :'0',event: this.filterPool[index].name};
  //         this.fetchdataByPeriod.emit(data);
  //       }
  //     }
  //     else{
  //       if(this.filterPool[index].option == 'rank'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdataRank.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'age'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdataByAgeGroup.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'nation'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdataByNational.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'firm'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdataByFirm.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'department'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdata.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'category'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdataCat.emit(data);
  //       }
  //       else if(this.filterPool[index].option == 'period'){
  //         let data = {event: this.filterPool[index].name};
  //         this.fetchdataByPeriod.emit(data);
  //       }
  //     }
  //   }
  // }


  // removeDataFromFilterPool(data){
  //   let baseValue = 0;
  //   for(let index = 0; index<this.filterPool.length; index++){
  //     if(this.filterPool[index].name == data.name){
  //       baseValue = index;
  //     }
  //   }
  //   if(baseValue > -1){
  //     this.filterPool.splice(baseValue, 1);
  //   }
  //   this.reselectAllFilterFromFilterPool();
  //   this.filterService.filterPoolSubject.next(this.filterPool);

  // }

  removeTypeDataFromFilterPool(filterType: string) {
    this.filterPool = this.filterPool.filter(data => data.option !== filterType);
    this.filterService.filterPoolSubject.next(this.filterPool);
  }

  onselectDepartment1(department: any, ...argu) {

    let category = '';
    let rank = '';
    let depArray = [];
    let catArray = [];
    let rankArray = [];
    if (argu[0]) {
      category = argu[0];
    }
    if (argu[1]) {
      rank = argu[1];
    }
    if (department && department !== 'Select Department') {
      this.crewList = [...this.crewListClone];
      this.applydepFilter(this.crewList, department);

      if (category && category !== 'Select Category') {
        this.applycatFilter(this.crewList, category);

        if (rank && rank !== 'Select Rank') {
          this.applyrankFilter(this.crewList, rank);
        }
        else {
          this.crewList = [...this.crewListClone];
          this.applydepFilter(this.crewList, department);
          this.applycatFilter(this.crewList, category);
        }
      }
      else {
        this.applydepFilter(this.crewList, department);
      }
    }
    else {
      this.crewList = [...this.crewListClone];
    }
    this.fetchdata.emit(this.crewList);
  }


  applydepFilter(crewArray: any, filterType: any) {
    this.crewList = crewArray.filter((crew: any) => {
      return crew.department.indexOf(filterType) > -1;
    })
  }

  applycatFilter(crewArray: any, filterType: any) {
    this.crewList = crewArray.filter((crew: any) => {
      return crew.category.indexOf(filterType) > -1;
    })
  }

  applyrankFilter(crewArray: any, filterType: any) {
    this.crewList = crewArray.filter((crew: any) => {
      return crew.rank.indexOf(filterType) > -1;
    })
  }


  // onselectPeriod(event: any){
  //   this.searchInputCrewId.nativeElement.value = '';
  //   this.searchInputName.nativeElement.value = '';
  //   let diffBase = event;
  //   let data = {event: diffBase};
  //   console.log('on select Period ', data);
  //   this.removeTypeDataFromFilterPool('period');
  //   this.fetchdataByPeriod.emit(data);
  //   let filterPoolData = {option:'period',name: diffBase};
  //     this.saveToFilterPool(filterPoolData);
  //   this.selectedPeriod.push(filterPoolData);
  // }

  onselectPeriod(event: any) {
    this.searchInputCrewId.nativeElement.value = '';
    this.searchInputName.nativeElement.value = '';
    // this.searchInputDep.nativeElement.value = 'Select Department';
    // this.searchInputRank.nativeElement.value = 'Select Rank';
    // this.searchInputCat.nativeElement.value = 'Select Category';
    let diffBase = event.srcElement.value
    let data = { event: diffBase };
    console.log('on select Period ', data);
    this.removeTypeDataFromFilterPool('period');
    this.fetchdataByPeriod.emit(data);
    if (diffBase !== 'From Beginning') {
      let filterPoolData = { option: 'period', name: diffBase };
      this.saveToFilterPool(filterPoolData);
      this.selectedPeriod.push(filterPoolData);

    }
    else if (diffBase == 'From Beginning') {
      this.removeTypeDataFromFilterPool('period');
      this.selectedPeriod = [];
    }
  }




  //method for finding the category
  checkCategory(dedepartmentValue, categoryValue) {
    let catArray = [];
    console.log('data ', this.departCatRankList);
    for (let i = 0; i < this.departCatRankList.length; i++) {
      if (this.departCatRankList[i].department == dedepartmentValue) {
        catArray.push(this.departCatRankList[i].category);
      }
    }
    if (catArray.indexOf(categoryValue) > -1) {
      return true;
    }
    else {
      return false;
    }
  }

  checkRank(dedepartmentValue, categoryValue, rankValue) {
    let rankArray = [];
    for (let i = 0; i < this.departCatRankList.length; i++) {
      if (this.departCatRankList[i].department == dedepartmentValue && this.departCatRankList[i].category == categoryValue) {
        rankArray.push(this.departCatRankList[i].rank);
      }
    }
    if (rankArray.indexOf(rankValue) > -1) {
      return true;
    }
    else {
      return false;
    }
  }


  getRankOrder(department, category, rank) {
    // console.log('getRANKoRDER ',department,category,rank);
    // console.log(this.departCatRankList);
    let rankOrder = '';
    this.departCatRankList.filter((data: any) => {
      if (data.department.toLowerCase() == department.toLowerCase() && data.category.toLowerCase() == category.toLowerCase() && data.rank.toLowerCase() == rank.toLowerCase()) {
        rankOrder = data.rankOrder;
      }
    })
    return rankOrder;
  }





  //validate Nationality in sheets.
  validateNationalities(nation) {
    let nationalityListLowerCase = [];
    for (let index = 0; index < this.nationalityList.length; index++) {
      nationalityListLowerCase.push(this.nationalityList[index].toLowerCase());
    }
    if (nationalityListLowerCase.indexOf(nation.toLowerCase()) > -1) {
      return true;
    }
    else {
      return false;
    }
  }

  //check Case Senstivity
  checkCaseSensNation(nation) {
    let nationInDB = '';
    for (let index = 0; index < this.nationalityList.length; index++) {
      if (this.nationalityList[index].toLowerCase() == nation.toLowerCase()) {
        nationInDB = this.nationalityList[index];
        break;
      }
    }
    return nationInDB;
  }

  // check everyone nation in sheet
  checkNation(list: any) {
    console.log('list ', list);
    let errorArray = [];
    let status = true;
    let errorMessage = 'Invalid value for nationality at';
    for (let index = 0; index < list.length; index++) {
      status = this.validateNationalities(list[index].nationality);
      if (status === false) {
        errorArray.push(index + 2);
        errorMessage = errorMessage + ' ' + (index + 2) + ' ';
      }
      else {
        list[index].nationality = this.checkCaseSensNation(list[index].nationality);
      }
    }

    if (errorArray.length > 0) {
      return errorMessage;
    }
    else if (errorArray.length == 0) {
      return 0;
    }
  }

  //method for finding the department 
  checkDepartment(departmentValue) {
    let crewdepartments = [];
    for (let index = 0; index < this.departments.length; index++) {
      crewdepartments.push(this.departments[index].toLowerCase());
    }
    if (crewdepartments.indexOf(departmentValue.toLowerCase()) > -1) {
      return true;
    }
    else {
      return false;
    }

  }

  checkDepartmentCaseSenstivity(departmentValue) {
    let departmentInDB = '';
    for (let index = 0; index < this.departments.length; index++) {
      if (this.departments[index].toLowerCase() === departmentValue.toLowerCase()) {
        departmentInDB = this.departments[index];
        break;
      }
    }
    return departmentInDB;
  }

  //check the only department value in sheet
  checkDepartmentValue(list: any) {
    console.log('list ', list);
    let errorArray = [];
    let status = true;
    let errorMessage = 'Invalid value for Department at';
    for (let index = 0; index < list.length; index++) {
      status = this.checkDepartment(list[index].department);
      if (status === false) {
        errorArray.push(index + 2);
        errorMessage = errorMessage + ' ' + (index + 2) + ' ';
      }
      else {
        list[index].department = this.checkDepartmentCaseSenstivity(list[index].department);
      }
    }
    console.log('check dep ', list);
    if (errorArray.length > 0) {
      return errorMessage;
    }
    else if (errorArray.length == 0) {
      return 0;
    }
  }

  //check only category valid value in sheet
  findCategory(category) {
    let crewCategory = [];
    for (let index = 0; index < this.categories.length; index++) {
      crewCategory.push(this.categories[index].toLowerCase());
    }
    if (crewCategory.indexOf(category.toLowerCase()) > -1) {
      return true;
    }
    else {
      return false;
    }
  }

  // case sensitivity for category
  checkCategoryCaseSensitive(category) {
    let CategoryCase = '';
    for (let index = 0; index < this.categories.length; index++) {
      if (this.categories[index].toLowerCase() === category.toLowerCase()) {
        CategoryCase = this.categories[index];
      }
    }
    return CategoryCase;
  }

  //validate the all category values in sheet
  validateCategory(list: any) {
    console.log('list ', list);
    let errorArray = [];
    let status = true;
    let errorMessage = 'Invalid value for Category at';
    for (let index = 0; index < list.length; index++) {
      status = this.findCategory(list[index].category);
      if (status === false) {
        errorArray.push(index + 2);
        errorMessage = errorMessage + ' ' + (index + 2) + ' ';
      }
      else {
        list[index].category = this.checkCategoryCaseSensitive(list[index].category);
      }
    }
    if (errorArray.length > 0) {
      return errorMessage;
    }
    else if (errorArray.length == 0) {
      return 0;
    }
  }

  //find the rank in rank array.
  findRank(rank) {
    let crewRank = [];
    for (let index = 0; index < this.ranks.length; index++) {
      crewRank.push(this.ranks[index].toLowerCase());
    }
    if (crewRank.indexOf(rank.toLowerCase()) > -1) {
      return true;
    }
    else {
      return false;
    }
  }

  //check rank Case sensitivity.
  checkRankCaseSenstivity(rank) {
    let crewRank = '';
    for (let index = 0; index < this.ranks.length; index++) {
      if (this.ranks[index].toLowerCase() == rank.toLowerCase()) {
        crewRank = this.ranks[index];
      }
    }
    return crewRank;
  }

  //validate the all rank values in sheet
  validateRank(list: any) {
    let errorArray = [];
    let status = true;
    let errorMessage = 'Invalid value for Rank at';
    for (let index = 0; index < list.length; index++) {
      status = this.findRank(list[index].rank);
      if (status == false) {
        errorArray.push(index + 2);
        errorMessage = errorMessage + ' ' + (index + 2) + ' ';
      }
      else {
        list[index].rank = this.checkRankCaseSenstivity(list[index].rank);
      }
    }
    if (errorArray.length > 0) {
      return errorMessage;
    }
    else if (errorArray.length == 0) {
      return 0;
    }
  }


  //find Department , category , rank according to master table
  findDepCatRank(department, category, rank) {
    let errorCount = false;
    for (let index = 0; index < this.departCatRankList.length; index++) {
      if (this.departCatRankList[index].department.toLowerCase() == department.toLowerCase() && this.departCatRankList[index].category.toLowerCase() == category.toLowerCase() && this.departCatRankList[index].rank.toLowerCase() == rank.toLowerCase()) {
        errorCount = true;
        break;
      }
      else {
        errorCount = false;
      }
    }
    return errorCount;
  }

  //check the case senstivity for DepCatRank
  checkDepCatRankCaseSenstivity(department, category, rank) {
    let depCatRank = {
      department: '',
      category: '',
      rank: ''
    };
    for (let index = 0; index < this.departCatRankList.length; index++) {
      if (this.departCatRankList[index].department.toLowerCase() == department.toLowerCase() && this.departCatRankList[index].category.toLowerCase() == category.toLowerCase() && this.departCatRankList[index].rank.toLowerCase() == rank.toLowerCase()) {
        depCatRank.department = this.departCatRankList[index].department;
        depCatRank.category = this.departCatRankList[index].category;
        depCatRank.rank = this.departCatRankList[index].rank;
      }
    }
    return depCatRank;
  }

  //check department, category, rank according to master table.
  validateDepCatRank(list) {
    console.log('list ', list);
    let errorArray = [];
    let status = true;
    let errorMessage = 'Department , Category , Rank at line ';
    for (let index = 0; index < list.length; index++) {
      status = this.findDepCatRank(list[index].department, list[index].category, list[index].rank);
      if (status === false) {
        errorArray.push(index + 2);
        errorMessage = errorMessage + ' ' + (index + 2) + ' , ';
      }
      else {
        let depCatRankObject = this.checkDepCatRankCaseSenstivity(list[index].department, list[index].category, list[index].rank);
        list[index].department = depCatRankObject.department;
        list[index].category = depCatRankObject.category;
        list[index].rank = depCatRankObject.rank;
      }
    }
    console.log('DEPCATRANK ', list);
    if (errorArray.length > 0) {
      errorMessage = errorMessage + 'are wrong not according to Master table.'
      return errorMessage;
    }
    else if (errorArray.length == 0) {
      return 0;
    }
  }

  checkCrewId(crewDataList, crewId) {
    let crewIdStatus = true;
    for (let i = 0; i < crewDataList.length; i++) {
      if (crewDataList[i].crewId.toLowerCase() == crewId.toLowerCase()) {
        console.log('in db');
        crewIdStatus = false;
      }
    }
    return crewIdStatus;
  }

  // validate crewId from database
  validateCrewId(list) {
    let errorArray = [];
    for (let i = 0; i < list.length; i++) {
      let crewIdCheck = this.checkCrewId(this.crewListClone, list[i].crewId);
      if (crewIdCheck === false) {
        errorArray.push(i + 1);
      }
    }
    return errorArray;
  }




  // logic for bulk upload
  onFileChange(event) {
    this.appSpinner.show();
    let workBook = null;
    let jsonData = null;
    let crewIdErrorMessage: any = '';
    let crewIdErrorArray = [];
    let departmentErroMessage: any = '';
    let catErrorMsg: any = '';
    let rankErrorMsg: any = '';
    let departCatRankValidation: any = '';
    let inFileCheck = 0;
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'string', dateNF: 'dd/mm/yyyy;@', cellDates: true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      let userJsonData = [];
      for (let i = 0; i < jsonData.Sheet1.length; i++) {
        let dateInStringFormat = JSON.stringify(jsonData.Sheet1[i].DateofBirth);
        console.log('json sheet ', jsonData.Sheet1[i]);
        console.log('json date type ', typeof (jsonData.Sheet1[i].DateofBirth));
        let dateParts;
        let dob;
        if (dateInStringFormat.indexOf('T') > -1) {
          var d = new Date(jsonData.Sheet1[i].DateofBirth);
          console.log('date indiff');
          console.log(d.getUTCDate()); // Hours
          console.log(d.getUTCMonth());
          console.log(d.getUTCFullYear());
          jsonData.Sheet1[i].DateofBirth = d.getUTCDate() + "-" + (d.getUTCMonth() + 2) + "-" + d.getUTCFullYear();
          // dateParts = jsonData.Sheet1[i].DateofBirth.split("-");
          dob = new Date(d.getUTCFullYear(), d.getUTCDate(), d.getUTCMonth() + 1);

        }
        else if (dateInStringFormat.indexOf('-') > -1) {
          dateParts = jsonData.Sheet1[i].DateofBirth.split("-");
          dob = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

        }

        userJsonData[i] = {};
        userJsonData[i].firstName = jsonData.Sheet1[i].Name;
        userJsonData[i].anotherName = jsonData.Sheet1[i].OtherNames;
        userJsonData[i].rank = jsonData.Sheet1[i].Rank;
        userJsonData[i].rankOrder = this.getRankOrder(jsonData.Sheet1[i].Department, jsonData.Sheet1[i].Category, jsonData.Sheet1[i].Rank);
        userJsonData[i].crewId = jsonData.Sheet1[i].CrewID;
        userJsonData[i].nationality = jsonData.Sheet1[i].Nationality;
        userJsonData[i].dob = dob
        userJsonData[i].category = jsonData.Sheet1[i].Category;
        userJsonData[i].department = jsonData.Sheet1[i].Department;
      }
      jsonData.Sheet1 = userJsonData;
      const dataString = JSON.stringify(jsonData);


      // for validating the crewId
      let crewIdArray = [];
      let errorCode = 0;
      let status = true;

      //getting the crewId in an array
      for (let i = 0; i < jsonData.Sheet1.length; i++) {
        crewIdArray.push(jsonData.Sheet1[i].crewId);
      }

      //logic for getting the duplicate crewId rows.
      for (let index = 0; index < crewIdArray.length - 1; index++) {
        for (let subindex = index + 1; subindex < crewIdArray.length; subindex++) {
          if (crewIdArray[index].toLowerCase() === crewIdArray[subindex].toLowerCase()) {
            if (index == crewIdArray.length - 2) {
              crewIdErrorArray.push(subindex + 1);
            }
            else {
              if (crewIdErrorArray.indexOf(index + 1) == -1 && crewIdErrorArray.indexOf(subindex + 1) == -1) {
                crewIdErrorArray.push(index + 1);
                crewIdErrorArray.push(subindex + 1);
                break;
              }
            }

          }
        }
      }

      //giving the value 1 to inFileCheck to show that the file  has error. 
      if (crewIdErrorArray.length > 0) {
        inFileCheck = 1
        errorCode = 1;
        console.log('erro check1 ', errorCode);
      }

      //sorting the duplicate crewId places find in file
      crewIdErrorArray = crewIdErrorArray.sort(function (a, b) {
        return a - b;
      })
      console.log('self ', crewIdErrorArray);

      //End for checking the duplicacy for CrewId in file


      //for checking the nationality values
      let nationalityError = this.checkNation(jsonData.Sheet1);
      console.log('nationalityError ', nationalityError);
      if (nationalityError != 0) {
        inFileCheck = 1;
        errorCode = 1;
        console.log('error nation ', errorCode);
      }
      // else if(nationalityError == 0){
      //   userJsonData[i].nationality = 
      // }



      //for checking the valid department value
      departmentErroMessage = this.checkDepartmentValue(jsonData.Sheet1);
      console.log('departmentErroMessage ', departmentErroMessage);
      if (departmentErroMessage != 0) {
        inFileCheck = 1;
        errorCode = 1;
        console.log('erro Depart ', errorCode);
      }

      //for checking the valid category value
      catErrorMsg = this.validateCategory(jsonData.Sheet1);
      console.log('catErrorMsg ', catErrorMsg);
      if (catErrorMsg != 0) {
        inFileCheck = 1;
        errorCode = 1;
        console.log('erro cat ', errorCode);
      }

      //for checking the valid rank value
      rankErrorMsg = this.validateRank(jsonData.Sheet1);
      console.log('rankErrorMsg ', rankErrorMsg);
      if (rankErrorMsg != 0) {
        inFileCheck = 1;
        errorCode = 1;
        console.log('erro rank ', errorCode);
      }


      //checking the department, category and rank from master table
      if (departmentErroMessage === 0 && catErrorMsg === 0 && rankErrorMsg === 0) {
        departCatRankValidation = this.validateDepCatRank(jsonData.Sheet1);
        console.log('departCatRankValidation ', departCatRankValidation);
        if (departCatRankValidation != 0) {
          inFileCheck = 1;
          errorCode = 1;
          console.log('erro check2 ', errorCode);
        }
      }

      //checking the already crewId in database.
      if (inFileCheck == 0) {
        crewIdErrorArray = this.validateCrewId(jsonData.Sheet1);
        console.log('data crewId check ', crewIdErrorArray);
        if (crewIdErrorArray.length > 0) {
          errorCode = 1;
          console.log('erro check1 ', errorCode);
        }
      }

      //message body for crewId based errors.
      if (crewIdErrorArray.length > 0 && inFileCheck == 0) {
        crewIdErrorMessage = 'CrewId at line ';
        for (let i = 0; i < crewIdErrorArray.length; i++) {
          if (i > 0) {
            crewIdErrorMessage = crewIdErrorMessage + ', ' + (crewIdErrorArray[i] + 1) + ' ';
          }
          else {
            crewIdErrorMessage = crewIdErrorMessage + (crewIdErrorArray[i] + 1) + ' ';
          }
        }
        crewIdErrorMessage = crewIdErrorMessage + 'Already Exist in Database';
      }
      else if (crewIdErrorArray.length > 0 && inFileCheck == 1) {
        crewIdErrorMessage = 'Duplicate CrewId at lines ';
        for (let i = 0; i < crewIdErrorArray.length; i++) {
          if (i > 0) {
            crewIdErrorMessage = crewIdErrorMessage + ', ' + (crewIdErrorArray[i] + 1) + ' ';
          }
          else {
            crewIdErrorMessage = crewIdErrorMessage + (crewIdErrorArray[i] + 1) + ' ';
          }
        }
        crewIdErrorMessage = crewIdErrorMessage + 'In the File';
      }
      else {
        crewIdErrorMessage = 0;
      }

      console.log('error code ', errorCode);
      if (errorCode == 0) {
        this.crewService.bulkUploadUsers(jsonData.Sheet1).subscribe((data: any) => {
          this.appSpinner.hide();
          this.msg = AppConstant.FILE_SUCCESS_STATUS;
          this.customDialogService.showDialog(this.msg, 'dismiss').subscribe(actionType => {
            if (actionType == 'dismiss') {
              location.reload();
            }
          })
        }, (error) => {
          this.appSpinner.hide();
          this.msg = AppConstant.FILE_FAILURE_STATUS;
          this.customDialogService.showDialog(this.msg, 'dismiss');
        })
      }
      else {
        console.log('errors');
        console.log(nationalityError);
        console.log(rankErrorMsg);
        console.log(catErrorMsg);
        console.log(departmentErroMessage);
        console.log(departCatRankValidation);
        console.log(crewIdErrorMessage);
        let errorsList = [];
        if (nationalityError != 0) {
          errorsList.push(nationalityError);
        }
        if (crewIdErrorMessage != 0) {
          errorsList.push(crewIdErrorMessage);
        }
        if (departmentErroMessage != 0) {
          errorsList.push(departmentErroMessage);
        }
        if (catErrorMsg != 0) {
          errorsList.push(catErrorMsg);
        }
        if (rankErrorMsg != 0) {
          errorsList.push(rankErrorMsg);
        }
        if (departCatRankValidation != 0) {
          errorsList.push(departCatRankValidation);
        }
        for (let index = 0; index < errorsList.length; index++) {
          errorsList[index] = (index + 1) + ' :- ' + errorsList[index];
        }

        this.msg = AppConstant.FILE_FAILURE_STATUS
        this.customDialogService.showBulkUploadDialog(this.msg, errorsList, 'failedToSubmit');
        this.appSpinner.hide();
      }

    }
    reader.readAsBinaryString(file);
    this.appSpinner.hide();
  }

  closeThisKeyword() {

  }
  ratingScale() {
    this.customDialogService.showRatingScaleDialogue(AppConstant.Rating_Scale, 'ratingScale');
  }

  toggleView() {
    this.isListView = !this.isListView;
    if (this.isListView) {
      this.toggleImage = '../../../../../../assets/images/toggle-chartview.png';
      this.fetchViewType.emit(true);
    } else {
      this.toggleImage = '../../../../../../assets/images/toggle-chartview-1.png';
      this.fetchViewType.emit(false);
      this.filterService.filterPoolSubject.next(this.filterPool);
    }
  }
}
